export function tenorFormatValidator() {
  return (control) => {
    const tenor = control.value;
    if (!tenor) {
      return null;
    }
    const regex = /^[0-9]{1,3}[myMY]{1}/;
    if (!regex.test(tenor)) {
      return {
        incorrect: true,
        message:
          'Please use the correct formatting for tenor e.g. 5M, 11M or 2Y',
      };
    }

    return null;
  };
}
